import { render, staticRenderFns } from "./PerformanceScenariosSection.vue?vue&type=template&id=1cfcfb34"
import script from "./PerformanceScenariosSection.vue?vue&type=script&lang=js"
export * from "./PerformanceScenariosSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports